import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { ToastContent, getToastContent } from "constants/toasts";
import { ApiManager } from "services/api";
import { ToastVariant, ToastsActions } from "store/features/toasts";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useResendInvitation = () => {
  const dispatch = useDispatch();

  const {
    mutate: resendInvitation,
    isLoading: resendingInvitation,
    isSuccess: invitationReminderSent,
  } = useMutation({
    mutationFn: async (id: string) => {
      const { error } = await ApiManager.agentApi.resendInvitation(id);
      if (error) {
        dispatch(
          ToastsActions.createToast({
            variant: ToastVariant.Error,
            content: getToastContent(ToastContent.RESEND_INVITATION_FAILURE),
          })
        );
        throw error;
      }
    },
    onSuccess: () => {
      dispatch(
        ToastsActions.createToast({
          variant: ToastVariant.Success,
          content: getToastContent(ToastContent.RESEND_INVITATION_SUCCESS),
        })
      );
    },
  });

  return {
    resendInvitation,
    resendingInvitation,
    invitationReminderSent,
  };
};
